<template>
  <div class="vb-services" :class="{ 'vb-services--boxed': boxed }">
    <flights v-if="has_flights" :flights="services.flights"></flights>
    <hotels
      :class="hotels_spacing_class"
      :hotels="services.hotels"
      :supplements="services.travelSupplements"
      :boxed="boxed"
      :flight_and_stay="has_flights"
      :statics_fallback="statics_fallback"
    ></hotels>
  </div>
</template>

<script>
import Flights from "@alpitour/components/blocks/flights.vue";
import Hotels from "@alpitour/components/blocks/hotels.vue";
import { has_flights } from "@alpitour/utilities";
export default {
  name: "services",
  props: {
    services: Object,
    boxed: {
      type: Boolean,
      default: false,
    },
    statics_fallback: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    flights: Flights,
    hotels: Hotels,
  },
  computed: {
    has_flights() {
      return has_flights(this.services);
    },
    hotels_spacing_class() {
      if (!this.has_flights) return "";
      return this.boxed ? "vb-services__block" : "mt-4";
    },
  },
};
</script>

<style lang="scss">
.vb-services {
  background-color: $white;
  border-radius: $border-radius-lg;
  padding: 1.25rem;
  margin-bottom: $grid-gutter-width;

  &--boxed {
    background-color: transparent;
    border-radius: 0;
    padding: 0;
    margin-bottom: 0;
  }

  &__block {
    margin-top: $grid-gutter-width;
  }
}
</style>
